import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";

const textareaVariants = cva(
    "flex w-full transition-colors file:font-medium file:text-sm placeholder:text-muted-foreground rounded-md bg-transparent text-base shadow-sm focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
    {
        variants: {
            variant: {
                default:
                    "border border-input focus-visible:ring-1 focus-visible:ring-primary-dark",
                invisible:
                    "border-none resize-none bg-transparent shadow-none appearance-none focus-visible:ring-0",
            },
            size: {
                default: "min-h-[80px] px-3 py-2",
                mailInput: "min-h-20 pt-2",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
);

export interface TextareaProps
    extends
        Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "size">,
        VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, variant, size, ...props }, ref) => (
        <textarea
            ref={ref}
            className={cn(textareaVariants({ variant, size, className }))}
            {...props}
        />
    ),
);
Textarea.displayName = "Textarea";

export { Textarea };
